import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';

const AdminPanel = ({ backendUrl }) => {
  const navigate = useNavigate();
  
  // Safe MSAL access - handle missing context
  let instance = null;
  let accounts = [];
  try {
    const msal = useMsal();
    instance = msal.instance;
    accounts = msal.accounts;
  } catch (error) {
    console.warn('MSAL not available:', error.message);
  }

  // If already authenticated, redirect to dashboard
  useEffect(() => {
    if (accounts.length > 0) {
      // Already logged in with Microsoft - redirect to dashboard
      navigate('/admin/dashboard');
    }
  }, [navigate, accounts]);

  const handleLogin = () => {
    // Trigger Microsoft Entra ID login
    instance.loginRedirect(loginRequest);
  };

  // Show login screen for Microsoft Entra ID
  return (
    <div className="fixed inset-0 z-[9999] min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center p-4">
      <div className="bg-white/10 backdrop-blur-md rounded-xl p-8 border border-white/20 max-w-md w-full">
        <h1 className="text-3xl font-bold text-white mb-6 text-center">
          TagQuest Admin
        </h1>
        
        <div className="space-y-4">
          <p className="text-white/80 text-sm text-center mb-4">
            Microsoft Entra ID Authentication
          </p>
          <div className="bg-blue-500/20 border border-blue-500 rounded-lg p-4 mb-4">
            <p className="text-blue-400 text-sm">
              🔐 Secure Microsoft login required
            </p>
            <p className="text-white/70 text-xs mt-2">
              You'll be redirected to Microsoft to sign in
            </p>
          </div>
          <button
            onClick={handleLogin}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors"
          >
            Login with Microsoft
          </button>
          <p className="text-white/60 text-xs text-center mt-4">
            Admin access for @pyebarkerfs.com accounts only
          </p>
        </div>
        
        <button
          onClick={() => navigate('/')}
          className="w-full mt-4 text-white/60 hover:text-white text-sm transition-colors"
        >
          ← Back to App
        </button>
      </div>
    </div>
  );
};

export default AdminPanel;
